export default __webpack_public_path__ + "static/media/astro_sad.c8914383.png";